import Lenis from 'lenis'

export function shouldEnableSmoothScroll(): boolean {
  if (typeof window === 'undefined') return false
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false
  if (window.matchMedia('(hover: none)').matches) return false
  return true
}

export function initSmoothScroll(): Lenis | null {
  if (!shouldEnableSmoothScroll()) return null

  const lenis = new Lenis({
    lerp: 0.08,
    duration: 1.2,
    smoothWheel: true,
  })

  function raf(time: number): void {
    lenis.raf(time)
    requestAnimationFrame(raf)
  }
  requestAnimationFrame(raf)

  return lenis
}
